/* Product feature chunk. Loaded with cart features where product UI exists. */
function btyShortDescription( doc = document ) {
	let button  = doc.querySelector( '.read-more-btn' );
	let short   = doc.querySelector( '.short-content' );
	let content = doc.querySelector( '.full-content' );

	if ( ! short || ! button || ! content ) {
		return;
	}

	if ( button ) {
		const buttonHandle = function() {
			if ( content.style.display === "none" ) {
				short.style.display   = "none";
				content.style.display = "block";
				button.textContent    = btyStrings.product.read_less;
			} else {
				content.style.display = "none";
				short.style.display   = "block";
				button.textContent    = btyStrings.product.read_more;
			}
		}

		button.addEventListener( 'click', buttonHandle );
	}
}

function btyFormatPrice( money = 0, format = false ) {
	if ( 'string' === typeof( money ) ) {
		money = money.replace( '.', '' );
	}

	if ( false === format ) {
		format = btyGlobals.money_format;
	}

	let value            = '',
		placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

	function defaultOption( opt, def ) {
		return 'undefined' === typeof( opt ) ? def : opt;
	}

	function formatWithDelimiters( number, precision, thousands, decimal ) {
		precision = defaultOption( precision, 2 );
		thousands = defaultOption( thousands, ',' );
		decimal   = defaultOption( decimal, '.' );

		if ( isNaN( number ) || number == null ) {
			return 0;
		}

		number = ( number / 100.0 ).toFixed( precision );

		let parts   = number.split( '.' ),
			dollars = parts[0].replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands ),
			money   = parts[1] ? ( decimal + parts[1] ) : '';

		return dollars + money;
	}

	switch ( format.match( placeholderRegex )[1] ) {
		case 'amount':
			value = formatWithDelimiters( money, 2 );
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters( money, 0 );
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters( money, 2, '.', ',' );
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters( money, 0, '.', ',' );
			break;
		case 'amount_with_space_separator':
			value = formatWithDelimiters( money, 2, ' ', ',' );
			break;
		case 'amount_with_period_and_space_separator':
			value = formatWithDelimiters( money, 2, ' ', '.' );
			break;
		case 'amount_no_decimals_with_space_separator':
			value = formatWithDelimiters( money, 0, '.', '' );
			break;
		case 'amount_with_apostrophe_separator':
			value = formatWithDelimiters( money, 2, "'", '.' );
			break;
	}

	return format.replace( placeholderRegex, value );
}

function btyPriceHtml( price, compare_price = false, unit_price = false, unit_price_measurement = {} ) {
	let html         = '',
		regularPrice = btyStrings.product.regular_price;

	if ( compare_price && compare_price > price ) {
		const savedAmount = compare_price - price,
			saveLabel  = btyStrings.product.save || 'Save';

		html += '<span class="price">';
		html += '<span class="sr-only">' + btyStrings.product.sale_price + ': </span>';
		html += btyFormatPrice( price );
		html += '</span>';

		html += '<s class="regular-price">';
		html += '<span class="sr-only">' + regularPrice + ': </span>';
		html += btyFormatPrice( compare_price );
		html += '</s>';

		html += '<span class="product-sale-label">';
		html += '<span class="sr-only">' + btyStrings.product.on_sale + ': </span>';
		html += '<span class="sale-total">' + saveLabel + ' ' + btyFormatPrice( savedAmount ) + '</span>';
		html += '</span>';

	} else {
		html += '<span class="regular-price">';
		html += '<span class="sr-only">' + regularPrice + ': </span>';
		html += btyFormatPrice( price );
		html += '</span>';
	}

	if ( unit_price ) {
		html += '<span class="unit-price">';
		html += btyFormatPrice( unit_price ) + '/' + unit_price_measurement.quantity_unit;
		html += '</span>';
	}

	return html;
}

function btyUpdateVariantPrice( element, variant ) {
	if ( ! element || ! variant ) {
		return;
	}

	let onSale = Boolean(
		variant.compare_at_price
		&& variant.compare_at_price > variant.price
	);

	element.innerHTML = btyPriceHtml(
		variant.price,
		variant.compare_at_price,
		variant.unit_price,
		variant.unit_price_measurement
	);
	element.classList.toggle( 'price--on-sale', onSale );
	element.classList.toggle( 'price--sold-out', variant.available === false );
}

function btyAddToCartButtonHtml( price ) {
	return btyStrings.product.add_to_cart
		+ '<span class="add-to-cart-separator" aria-hidden="true"> - </span>'
		+ '<span class="add-to-cart-price">' + btyFormatPrice( price ) + '</span>';
}

function btyUpdateAddToCartTotals( section, quantity ) {
	let qty = Number( quantity );

	if ( ! Number.isFinite( qty ) || qty < 1 ) {
		qty = 1;
	}

	section.querySelectorAll( '.add-to-cart-button.has-price[data-unit-price]' ).forEach(
		function( button ) {
			let form      = button.closest( '[data-type="add-to-cart-form"]' ),
				unitPrice = Number( button.dataset.unitPrice );

			if (
				! Number.isFinite( unitPrice )
				|| button.classList.contains( 'disabled' )
				|| ( form && form.classList.contains( 'disabled' ) )
			) {
				return;
			}

			button.innerHTML = btyAddToCartButtonHtml( Math.round( unitPrice * qty ) );
		}
	);
}

function btyGetProductPurchasePrice( section ) {
	let priceDataElement = section.querySelector( '[data-product-selling-plan-prices]' ),
		mainForm         = section.querySelector( '.main-product .summary-item.add-to-cart [data-type="add-to-cart-form"]' );

	if ( ! priceDataElement || ! mainForm ) {
		return false;
	}

	if ( ! section.btySellingPlanPrices ) {
		section.btySellingPlanPrices = btyJsonParse( priceDataElement.textContent );
	}

	if ( ! Array.isArray( section.btySellingPlanPrices ) ) {
		return false;
	}

	let formData      = new FormData( mainForm ),
		variantId      = formData.get( 'id' ),
		sellingPlanId  = formData.get( 'selling_plan' ) || '',
		variantPricing = section.btySellingPlanPrices.find(
			item => String( item.variantId ) === String( variantId )
		);

	if ( ! variantPricing ) {
		return false;
	}

	let unitPrice = Number( variantPricing.price );

	if ( sellingPlanId ) {
		let allocation = variantPricing.allocations.find(
			item => String( item.sellingPlanId ) === String( sellingPlanId )
		);

		if ( allocation ) {
			unitPrice = Number( allocation.price );
		}
	}

	if ( ! Number.isFinite( unitPrice ) ) {
		return false;
	}

	return {
		variantId: String( variantId ),
		sellingPlanId: String( sellingPlanId ),
		unitPrice: unitPrice
	};
}

function btySyncProductPurchasePrice( section ) {
	let purchasePrice = btyGetProductPurchasePrice( section );

	if ( ! purchasePrice ) {
		return false;
	}

	section.querySelectorAll( '.add-to-cart-button.has-price[data-unit-price]' ).forEach(
		function( button ) {
			button.dataset.unitPrice = purchasePrice.unitPrice;
		}
	);

	let quantityInput = section.querySelector( '.main-product .summary-item.add-to-cart .quantity-input' )
		|| section.querySelector( '.sticky-add-to-cart .quantity-input' );
	let quantity = Number( quantityInput ? quantityInput.value : 1 ) || 1;

	btyUpdateAddToCartTotals( section, quantity );

	return purchasePrice.variantId + ':' + purchasePrice.sellingPlanId;
}

function btyWatchProductPurchasePrice( section ) {
	if (
		! section.querySelector( '[data-product-selling-plan-prices]' )
		|| section.btySellingPlanPriceTimer
	) {
		return;
	}

	let syncPrice = function() {
		if ( ! section.isConnected ) {
			window.clearInterval( section.btySellingPlanPriceTimer );
			section.btySellingPlanPriceTimer = null;
			return;
		}

		let purchasePrice = btyGetProductPurchasePrice( section );

		if ( ! purchasePrice ) {
			return;
		}

		let signature = purchasePrice.variantId + ':' + purchasePrice.sellingPlanId;

		if ( signature !== section.btySellingPlanPriceSignature ) {
			section.btySellingPlanPriceSignature = btySyncProductPurchasePrice( section );
		}
	};

	[ 'change', 'input' ].forEach(
		function( eventName ) {
			section.addEventListener( eventName, function() {
				window.setTimeout( syncPrice, 0 );
			}, true );
		}
	);

	section.addEventListener( 'click', function() {
		window.setTimeout( syncPrice, 0 );
		window.setTimeout( syncPrice, 100 );
	}, true );

	section.btySellingPlanPriceTimer = window.setInterval( syncPrice, 500 );
	syncPrice();
}

function btyUpdateBackInStockButton( section, selected ) {
	if ( ! selected ) {
		return;
	}

	let updateTrigger = function( trigger, addToCartButton ) {
		if ( ! trigger ) {
			return;
		}

		let form = trigger.closest( '[data-type="add-to-cart-form"]' ),
			showBackInStock = selected.available === false;

		trigger.dataset.variantId = selected.id;
		trigger.classList.toggle( 'hidden', ! showBackInStock );
		trigger.setAttribute( 'aria-hidden', showBackInStock ? 'false' : 'true' );

		if ( addToCartButton ) {
			addToCartButton.classList.toggle( 'hidden', showBackInStock );
		}

		if ( form ) {
			form.classList.toggle( 'back-in-stock-active', showBackInStock );

			if ( showBackInStock ) {
				form.classList.remove( 'disabled' );
			}
		}
	};

	let mainTrigger = section.querySelector( '.main-product [data-back-in-stock-button]' ),
		mainButton = mainTrigger
			? mainTrigger.closest( '[data-type="add-to-cart-form"]' ).querySelector( '[data-theme-cart-button]' )
			: false,
		stickyTrigger = section.querySelector( '.sticky-add-to-cart [data-sticky-back-in-stock-button]' ),
		stickyButton = stickyTrigger
			? stickyTrigger.closest( '[data-type="add-to-cart-form"]' ).querySelector( '[name="add"]' )
			: false;

	updateTrigger( mainTrigger, mainButton );
	updateTrigger( stickyTrigger, stickyButton );
}

function btyBackInStockButtons( doc = document ) {
	let buttons = [];

	if (
		doc.matches
		&& doc.matches( '[data-back-in-stock-button], [data-sticky-back-in-stock-button]' )
	) {
		buttons.push( doc );
	}

	buttons = buttons.concat(
		Array.from(
			doc.querySelectorAll( '[data-back-in-stock-button], [data-sticky-back-in-stock-button]' )
		)
	);

	buttons.forEach(
		function( button ) {
			if ( button.dataset.stoqTriggerReady === 'true' ) {
				return;
			}

			button.dataset.stoqTriggerReady = 'true';
			button.addEventListener(
				'click',
				function( event ) {
					event.preventDefault();

					if ( button.getAttribute( 'aria-busy' ) === 'true' ) {
						return;
					}

					let section = button.closest( '.shopify-section' ) || document,
						productDataElement = button.closest( '.product-summary' )
							? button.closest( '.product-summary' ).querySelector( '[data-stoq-product]' )
							: section.querySelector( '[data-stoq-product]' ),
						productData = productDataElement ? btyJsonParse( productDataElement.textContent ) : false,
						variantId = button.dataset.variantId;

					let openModal = function() {
						if (
							! window._RestockRocket
							|| typeof window._RestockRocket.openModal !== 'function'
						) {
							return false;
						}

						if ( productData && variantId ) {
							window._RestockRocket.openModal( productData, String( variantId ) );
						} else {
							window._RestockRocket.openModal();
						}

						button.removeAttribute( 'aria-busy' );
						return true;
					};

					if ( openModal() ) {
						return;
					}

					button.setAttribute( 'aria-busy', 'true' );

					let onStoqLoaded = function() {
						window.clearTimeout( button.stoqLoadTimer );

						if ( ! openModal() ) {
							button.removeAttribute( 'aria-busy' );
						}
					};

					window.addEventListener( 'stoq:loaded', onStoqLoaded, { once: true } );
					button.stoqLoadTimer = window.setTimeout(
						function() {
							window.removeEventListener( 'stoq:loaded', onStoqLoaded );
							button.removeAttribute( 'aria-busy' );
						},
						5000
					);
				}
			);
		}
	);
}

function btyQuantityButton( doc = document ) {
	let buttons = doc.querySelectorAll( '.quantity-button' );
	if ( ! buttons.length ) {
		return;
	}

	buttons.forEach(
		function( el ) {
			let eventChange = new Event( 'change', { bubbles: true } );

			el.onclick = function() {
				let input = el.parentNode.querySelector( '.quantity-input' );
				if ( ! input ) {
					return;
				}

				let current = Number( input.value || 0 ),
					step    = Number( input.getAttribute( 'step' ) || 1 ),
					min     = Number( input.getAttribute( 'min' ) || 0 ),
					max     = Number( input.getAttribute( 'max' ) ),
					name    = el.name;

				if ( 'minus' === name && current >= step ) { // Minus button.
					if ( current <= min || ( current - step ) < min ) {
						return;
					}

					input.value = current - step;
				} else if ( 'plus' === name ) { // Plus button.
					if ( max && ( current >= max || ( current + step ) > max ) ) {
						return;
					}

					input.value = current + step;
				}

				// Trigger event.
				input.dispatchEvent( eventChange );
			}
		}
	);
}

function btyProductPurchaseControls( doc = document ) {
	let sections = [];

	if ( doc.matches && doc.matches( '.main-product-section' ) ) {
		sections.push( doc );
	}

	sections = sections.concat( Array.from( doc.querySelectorAll( '.main-product-section' ) ) );

	sections.forEach(
		function( section ) {
			let mainInput    = section.querySelector( '.main-product .summary-item.add-to-cart .quantity-input' ),
				stickyInput  = section.querySelector( '.sticky-add-to-cart .quantity-input' ),
				mainButton   = section.querySelector( '.main-product .summary-item.add-to-cart .add-to-cart-button' ),
				stickyButton = section.querySelector( '.sticky-add-to-cart .add-to-cart-button' ),
				mainForm     = mainButton ? mainButton.closest( '[data-type="add-to-cart-form"]' ) : false,
				stickyForm   = stickyButton ? stickyButton.closest( '[data-type="add-to-cart-form"]' ) : false;

			btyWatchProductPurchasePrice( section );

			if (
				mainButton
				&& stickyButton
				&& mainForm
				&& stickyForm
				&& stickyButton.dataset.mainProductFormSync !== 'true'
			) {
				let syncMainFormToSticky = function() {
					stickyForm.querySelectorAll( '[data-synced-product-field]' ).forEach(
						function( field ) {
							field.remove();
						}
					);

					let ignoredFields = [ 'id', 'quantity', 'form_type', 'utf8' ];

					new FormData( mainForm ).forEach(
						function( value, name ) {
							if (
								ignoredFields.includes( name )
								|| ( name.startsWith( '[' ) && name.endsWith( ']' ) )
								|| ( typeof File !== 'undefined' && value instanceof File )
							) {
								return;
							}

							let input = document.createElement( 'input' );
							input.type = 'hidden';
							input.name = name;
							input.value = value;
							input.setAttribute( 'data-synced-product-field', '' );
							stickyForm.appendChild( input );
						}
					);
				};

				stickyButton.dataset.mainProductFormSync = 'true';
				stickyButton.btySyncMainProductForm = syncMainFormToSticky;

				stickyButton.addEventListener(
					'click',
					function() {
						syncMainFormToSticky();
					},
					true
				);
			}

			if ( mainInput && stickyInput ) {
				let syncQuantity = function( source ) {
					if ( source.value === '' ) {
						return;
					}

					let min   = Number( mainInput.getAttribute( 'min' ) || 1 ),
						max   = Number( mainInput.getAttribute( 'max' ) ),
						value = Number( source.value );

					if ( ! Number.isFinite( value ) ) {
						value = min;
					}

					value = Math.max( min, value );

					if ( max && value > max ) {
						value = max;
					}

					mainInput.value = value;
					stickyInput.value = value;
					btyUpdateAddToCartTotals( section, value );
				};

				[ mainInput, stickyInput ].forEach(
					function( input ) {
						if ( input.dataset.productQuantitySync === 'true' ) {
							return;
						}

						input.dataset.productQuantitySync = 'true';
						input.addEventListener( 'input', function() {
							syncQuantity( input );
						} );
						input.addEventListener( 'change', function() {
							if ( input.value === '' ) {
								input.value = mainInput.getAttribute( 'min' ) || 1;
							}

							syncQuantity( input );
						} );
					}
				);

				stickyInput.value = mainInput.value;
				btyUpdateAddToCartTotals( section, mainInput.value );
			}

			section.querySelectorAll( '.sticky-add-to-cart .field-value' ).forEach(
				function( field ) {
					if ( field.dataset.productButtonPriceSync === 'true' ) {
						return;
					}

					field.dataset.productButtonPriceSync = 'true';
					field.addEventListener( 'change', function( event ) {
						event.stopImmediatePropagation();

						let variantData = section.querySelector( '.main-product [data-product-variants]' ),
							variants    = variantData ? btyJsonParse( variantData.textContent ) : [],
							variantPick = {};

						section.querySelectorAll( '.sticky-add-to-cart .field-value' ).forEach(
							function( variantField ) {
								variantPick[ variantField.name ] = variantField.value;
							}
						);

						let selected = btySelectedVariant( variantPick, variants );

						if ( selected ) {
							btyUpdateStickyPurchaseControls( section, selected, false );
							btySyncMainVariantFromSticky( section, selected );
						}
					}, true );
				}
			);
		}
	);

	if ( document.documentElement.dataset.productPurchaseSync !== 'true' ) {
		document.documentElement.dataset.productPurchaseSync = 'true';
		document.addEventListener(
			'product-variant-updated',
			function( event ) {
				let selected = event.detail ? event.detail.selected : false,
					source   = event.detail ? event.detail.source : false,
					section  = source && source.closest ? source.closest( '.main-product-section' ) : false;

				if ( selected && section ) {
					btyUpdateStickyPurchaseControls( section, selected, true );
					btyUpdateBackInStockButton( section, selected );
				}
			}
		);
	}
}

function btySyncMainVariantFromSticky( section, selected ) {
	let variantFields = [];

	section.querySelectorAll( '.main-product .product-summary .product-variants > .variant-field' ).forEach(
		function( group, index ) {
			let targetValue = selected.options ? selected.options[ index ] : false,
				fields      = group.querySelectorAll( '.field-value' ),
				activeField = false;

			if ( targetValue === false || targetValue === undefined ) {
				return;
			}

			fields.forEach(
				function( field ) {
					if ( field.type === 'radio' ) {
						field.checked = field.value === targetValue;

						if ( field.checked ) {
							activeField = field;
						}
					} else {
						field.value = targetValue;
						activeField = field;
					}
				}
			);

			if ( activeField ) {
				variantFields.push( activeField );
			}
		}
	);

	variantFields.forEach(
		function( field ) {
			field.dispatchEvent( new Event( 'change', { bubbles: true } ) );
		}
	);
}

function btyUpdateStickyPurchaseControls( section, selected, syncOptions = true ) {
	let sticky        = section.querySelector( '.sticky-add-to-cart' ),
		stickyForm     = sticky ? sticky.querySelector( '[data-type="add-to-cart-form"]' ) : false,
		stickyId       = stickyForm ? stickyForm.querySelector( '[name="id"]' ) : false,
		stickyButton   = stickyForm ? stickyForm.querySelector( '[name="add"]' ) : false,
		stickyPrice    = sticky ? sticky.querySelector( '.product-infomation .product-price' ) : false,
		stickyImage    = sticky ? sticky.querySelector( '.sticky-product-image' ) : false,
		mainInput      = section.querySelector( '.main-product .summary-item.add-to-cart .quantity-input' ),
		stickyInput    = stickyForm ? stickyForm.querySelector( '.quantity-input' ) : false;

	if ( ! stickyForm ) {
		return;
	}

	if ( stickyId ) {
		stickyId.value = selected.id;
	}

	if ( syncOptions && selected.options ) {
		sticky.querySelectorAll( '.field-value' ).forEach(
			function( field, index ) {
				if ( selected.options[ index ] !== undefined ) {
					field.value = selected.options[ index ];
				}
			}
		);
	}

	if ( stickyPrice ) {
		stickyPrice.innerHTML = btyPriceHtml(
			selected.price,
			selected.compare_at_price,
			selected.unit_price,
			selected.unit_price_measurement
		);
	}

	if ( stickyImage && selected.featured_image ) {
		stickyImage.removeAttribute( 'srcset' );
		btyImageLoad(
			stickyImage,
			selected.featured_image.src,
			selected.featured_media ? selected.featured_media.id : false,
			stickyImage.parentNode
		);
	}

	if ( stickyButton ) {
		if ( selected.available ) {
			let quantity = Number( mainInput ? mainInput.value : ( stickyInput ? stickyInput.value : 1 ) ) || 1;

			stickyButton.dataset.unitPrice = selected.price;
			stickyButton.innerHTML = btyAddToCartButtonHtml( selected.price * quantity );
			stickyButton.classList.remove( 'disabled' );
			stickyButton.disabled = false;
			stickyButton.setAttribute( 'aria-disabled', 'false' );
		} else {
			stickyButton.innerHTML = btyStrings.product.out_of_stock;
			stickyButton.classList.add( 'disabled' );
			stickyButton.disabled = true;
			stickyButton.setAttribute( 'aria-disabled', 'true' );
		}
	}

	stickyForm.classList.remove( 'disabled' );

	if ( mainInput && stickyInput ) {
		[ 'min', 'max', 'step' ].forEach(
			function( attribute ) {
				if ( mainInput.hasAttribute( attribute ) ) {
					stickyInput.setAttribute( attribute, mainInput.getAttribute( attribute ) );
				} else {
					stickyInput.removeAttribute( attribute );
				}
			}
		);

		stickyInput.value = mainInput.value;
	}
}

function btySelectedVariant( variant, data, slider ) {
	for ( let opt in data ) {
		if ( btyDiffObject( Object.values( variant ), data[opt].options ) ) {
			if ( 'object' === typeof( slider ) && Object.keys( slider ).length && data[opt].featured_media ) {
				slider.slideTo( ( data[opt].featured_media.position - 1 ), 500, false );
			}

			return data[opt];
		}
	}
}

function btyProductVariants(doc = document, output = false) {
	let data,
		selector = doc.querySelectorAll('.product-variants');
	if (!selector.length) return;

	selector.forEach(function (sl) {
		let variants = sl.parentNode.querySelector('[data-product-variants]'),
			quantity = sl.parentNode.querySelector('[data-inventory-quantity]'),
			field = sl.querySelectorAll('.field-value');
		if (!field.length || !variants || !quantity) return;

		let product      = sl.closest('.main-product'),
			gallery      = product ? product.querySelector('.product-gallery') : false,
			featured     = sl.closest('.featured-product-product'),
			image        = featured ? featured.querySelector('.media-preview') : false,
			summary      = sl.closest('.product-summary'),
			variant_pick = {};

		variants = btyJsonParse(variants.textContent);
		quantity = btyJsonParse(quantity.textContent);

		let price       = summary.querySelector('.product-price'),
			form        = summary.querySelector('[data-type="add-to-cart-form"]'),
			input       = form ? form.querySelector('.quantity-input') : false,
			productId   = form ? form.querySelector('[name="id"]') : false,
			button      = form ? form.querySelector('.add-to-cart-button') : false,
			price_2     = summary.querySelector('.product-price-floated .product-price'),
			form_2      = summary.querySelector('.product-floated-product-form [data-type="add-to-cart-form"]'),
			input_2     = form_2 ? form_2.querySelector('.quantity-input') : false,
			productId_2 = form_2 ? form_2.querySelector('[name="id"]') : false,
			button_2    = form_2 ? form_2.querySelector('.add-to-cart-button') : false,
			productUrl  = sl.getAttribute('data-url'),
			pickup      = summary.querySelector('.pickup-availability'),
			amount      = summary.querySelector('.product-sale-label .sale-total .saved-number');

		field.forEach(function (el) {
			if (el.type === 'radio') {
				if (el.checked) variant_pick[el.name] = el.value;
			} else {
				variant_pick[el.name] = el.value;
			}

			el.onchange = function () {
				variant_pick[el.name] = el.value;
				btyUpdateStockStatusProduct(variants, sl);

				let selected = btySelectedVariant(variant_pick, variants);

				if ( form ) {
					let sellingMessage = form.parentNode.querySelector( '.selling-plan-message' ),
						button         = form.querySelector( '.add-to-cart-button' ),
						paymentButton  = form.querySelector( '.shopify-payment-button' );

					if ( sellingMessage && ! sellingMessage.classList.contains( 'hidden' ) ) {
						sellingMessage.innerHTML = '';
						sellingMessage.classList.add( 'hidden' );
					}

					if ( selected.requires_selling_plan && selected.selling_plan_allocations.length == 0 ) {
						if ( button ) {
							button.classList.add( 'selling-plan-error' );
						}

						if ( paymentButton ) {
							paymentButton.classList.add( 'hidden' );
						}
					} else {
						if ( button ) {
							button.classList.remove( 'selling-plan-error' );
						}

						if ( paymentButton ) {
							paymentButton.classList.remove( 'hidden' );
						}
					}
				}

				if (!selected) {
					if (button) {
						button.classList.add('disabled');
						button.innerHTML = btyStrings.product.unavailable;
					}
					if (button_2) {
						button_2.classList.add('disabled');
						button_2.innerHTML = btyStrings.product.unavailable;
					}
					if (form) form.classList.add('disabled');
					if (form_2) form_2.classList.add('disabled');
					if (pickup) pickup.innerHTML = '';
					if (amount) amount.closest('.product-sale-label').classList.add('hidden');
					return;
				}

				if (productId) productId.value = selected.id;
				if (productId_2) productId_2.value = selected.id;

				if (image && selected.featured_image) {
					image.removeAttribute('srcset');
					btyImageLoad(image, selected.featured_image.src, selected.featured_media.id, image.parentNode);
				}

				if (productUrl && gallery) {
					window.history.replaceState({}, '', productUrl + '?variant=' + selected.id);
				}

				if (price) {
					btyUpdateVariantPrice(price, selected);
				}
				if (price_2) {
					btyUpdateVariantPrice(price_2, selected);
				}

				if (amount) {
					if (selected.compare_at_price) {
						let amountTotal = 100 * (selected.compare_at_price - selected.price) / selected.compare_at_price;
						amount.innerHTML = amountTotal.toFixed(0);
						amount.closest('.product-sale-label').classList.remove('hidden');
					} else {
						amount.closest('.product-sale-label').classList.add('hidden');
					}
				}

				if (input) {
					let max = quantity.filter(e => e.id === selected.id);
					if (max.length) {
						let qty = max[0].qty;
						if (qty > 0) {
							if (Number(input.value) > qty) input.value = qty;
							input.setAttribute('max', qty);
						} else {
							input.removeAttribute('max');
						}
					} else {
						input.removeAttribute('max');
					}
				}

				let groupImage = document.querySelectorAll('.check-group-image .swiper[data-color]');
				if (groupImage.length) {
					let colorName = selected.featured_media && selected.featured_media.alt ? selected.featured_media.alt.split('_')[0] : false;
					if (colorName) {
						groupImage.forEach(function (gi) {
							let label = gi.getAttribute('data-color');
							if (!label) return;
							if (colorName.trim().toLowerCase() == label) gi.classList.remove('group-hidden');
							else gi.classList.add('group-hidden');
						});
					}
				}

				let shopifyPayment = document.querySelector('shopify-payment-terms');
				if (shopifyPayment) shopifyPayment.setAttribute('variant-id', selected.id);

				if (pickup) {
					if (selected.available) btyPickupAvailability(doc, productId.value, pickup);
					else pickup.innerHTML = '';
				}

				let selectedOption = el.closest('.variant-field')?.querySelector('.field-title .selected-value');
				if (selectedOption) selectedOption.innerText = el.value.trim();

				if (form) form.classList.toggle('disabled', !selected.available);
				if (form_2) form_2.classList.toggle('disabled', !selected.available);

				if (button) {
					if (selected.available) {
						if (button.classList.contains('has-price')) {
							let selectedQuantity = Number(input ? input.value : 1) || 1;

							button.dataset.unitPrice = selected.price;
							button.innerHTML = btyAddToCartButtonHtml(selected.price * selectedQuantity);
						} else {
							button.innerHTML = btyStrings.product.add_to_cart;
						}

						button.classList.remove('disabled');
					} else {
						button.innerHTML = btyStrings.product.out_of_stock;
						button.classList.add('disabled');
					}
				}

				if (button_2) {
					if (selected.available) {
						button_2.innerHTML = btyStrings.product.add_to_cart;
						button_2.classList.remove('disabled');
					} else {
						button_2.innerHTML = btyStrings.product.out_of_stock;
						button_2.classList.add('disabled');
					}
				}

				document.dispatchEvent(new CustomEvent('product-variant-updated', { detail: { selected, source: sl } }));
			};

			if (amount?.textContent.trim()) {
				amount.closest('.product-sale-label')?.classList.remove('hidden');
			} else {
				amount?.closest('.product-sale-label')?.classList.add('hidden');
			}
		});

		let firstSelected = btySelectedVariant(variant_pick, variants);

		if (!firstSelected && variants.length) {
			let cheapest = variants.reduce((prev, curr) => (curr.price < prev.price ? curr : prev));
			firstSelected = cheapest;
			variant_pick = cheapest.options.reduce((obj, val, index) => {
				obj['option' + (index + 1)] = val;
				return obj;
			}, {});

			if (productId) productId.value = cheapest.id;
			if (productId_2) productId_2.value = cheapest.id;
			if (price) btyUpdateVariantPrice(price, cheapest);
			if (price_2) btyUpdateVariantPrice(price_2, cheapest);

			if (button) {
				if (cheapest.available) {

					if (button.classList.contains('has-price')) {
						let selectedQuantity = Number(input ? input.value : 1) || 1;

						button.dataset.unitPrice = cheapest.price;
						button.innerHTML = btyAddToCartButtonHtml(cheapest.price * selectedQuantity);
					} else {
						button.innerHTML = btyStrings.product.add_to_cart;
					}

					button.classList.remove('disabled');
				} else {
					button.classList.add('disabled');
					button.innerHTML = btyStrings.product.out_of_stock;
				}
			}

			if (button_2) {
				if (cheapest.available) {
					button_2.classList.remove('disabled');
					button_2.innerHTML = btyStrings.product.add_to_cart;
				} else {
					button_2.classList.add('disabled');
					button_2.innerHTML = btyStrings.product.out_of_stock;
				}
			}

			field.forEach(el => {
				let value = cheapest.options.find(v => v === el.value);
				if (value) {
					el.checked = true;
					el.dispatchEvent(new Event('change'));
				}
			});
		} else if (firstSelected) {
			let checkedField = sl.querySelector('.field-value:checked');
			if (checkedField) {
				checkedField.dispatchEvent(new Event('change'));
			}
		}

		if (pickup && firstSelected && firstSelected.available) btyPickupAvailability(doc, firstSelected.id, pickup);

		if (input && firstSelected) {
			let max = quantity.filter(e => e.id === firstSelected.id);
			if (max.length) {
				let qty = max[0].qty;
				if (qty > 0) {
					if (Number(input.value) > qty) input.value = qty;
					input.setAttribute('max', qty);
				} else {
					input.removeAttribute('max');
				}
			} else {
				input.removeAttribute('max');
			}
		}

		data = firstSelected;
	});

	if (output) return data;
}

function btyQuickViewVariants(doc = document, slider = {}) {
	let selector = doc.querySelector('.product-variants');
	if (!selector) return;

	let variants = selector.parentNode.querySelector('[data-product-variants]'),
		quantity = selector.parentNode.querySelector('[data-inventory-quantity]'),
		field    = selector.querySelectorAll('.field-value');
	if (!field.length || !variants || !quantity) return;

	let summary      = selector.closest('.product-summary') || selector.parentNode,
		image        = summary.querySelector('.media-preview'),
		form         = summary.querySelector('[data-type="add-to-cart-form"]'),
		price        = summary.querySelector('.product-price'),
		button       = form ? form.querySelector('[name="add"]') : false,
		productId    = form ? form.querySelector('[name="id"]') : false,
		input        = form ? form.querySelector('.quantity-input') : false,
		pickup       = summary.querySelector('.pickup-availability'),
		amount       = summary.querySelector('.product-sale-label .sale-total .saved-number'),
		productUrl   = selector.getAttribute('data-url'),
		productLink  = summary.querySelector('.product-url'),
		shareInput   = summary.querySelector('.product-share .field-input'),
		variant_pick = {};

	variants = btyJsonParse(variants.textContent);
	quantity = btyJsonParse(quantity.textContent);

	field.forEach((el) => {
		if (el.type === 'radio') {
			if (el.checked) variant_pick[el.name] = el.value;
		} else {
			variant_pick[el.name] = el.value;
		}

		el.onchange = function () {
			variant_pick[el.name] = el.value;
			btyUpdateStockStatusProduct(variants, selector);

			let selected = btySelectedVariant(variant_pick, variants, slider);
			if (!selected) {
				if (button) {
					button.classList.add('disabled');
					button.innerHTML = btyStrings.product.unavailable;
				}
				if (form) form.classList.add('disabled');
				if (pickup) pickup.innerHTML = '';
				if (amount) amount.closest('.product-sale-label')?.classList.add('hidden');
				return;
			}

			// Check variant selling plan.
			if ( form ) {
				let sellingMessage = form.parentNode.querySelector( '.selling-plan-message' );

				if ( sellingMessage && ! sellingMessage.classList.contains( 'hidden' ) ) {
					sellingMessage.innerHTML = '';
					sellingMessage.classList.add( 'hidden' );
				}
			}

			if (productId) productId.value = selected.id;

			if (image && selected.featured_image) {
				image.removeAttribute('srcset');
				btyImageLoad(image, selected.featured_image.src, selected.featured_media?.id, image.parentNode);
			}

			if (productUrl) {
				if (productLink) productLink.href = productUrl + '?variant=' + selected.id;
				if (shareInput) shareInput.value = window.location.origin + productUrl + '?variant=' + selected.id;
			}

			if (price) {
				price.innerHTML = btyPriceHtml(selected.price, selected.compare_at_price, selected.unit_price, selected.unit_price_measurement);
			}

			if (amount) {
				if (selected.compare_at_price) {
					let amountTotal = 100 * (selected.compare_at_price - selected.price) / selected.compare_at_price;
					amount.innerHTML = amountTotal.toFixed(0);
					amount.closest('.product-sale-label')?.classList.remove('hidden');
				} else {
					amount.closest('.product-sale-label')?.classList.add('hidden');
				}
			}

			if (input) {
				let max = quantity.find(e => e.id === selected.id);
				if (max) {
					let qty = max.qty;
					if (qty > 0) {
						if (Number(input.value) > qty) input.value = qty;
						input.setAttribute('max', qty);
					} else input.removeAttribute('max');
				} else input.removeAttribute('max');
			}

			if (form) form.classList.toggle('disabled', !selected.available);

			if (button) {
				if (selected.available) {
					let priceHTML = '';
					if (selected.compare_at_price && selected.compare_at_price > selected.price) {
						const discount = Math.round((1 - selected.price / selected.compare_at_price) * 100);
						priceHTML = `
							<span> - </span>
							<div class="product-price price--on-sale">
								<div class="price__sale">
									<span class="price">$${(selected.price / 100).toFixed(2)}</span>
									<s class="regular-price">$${(selected.compare_at_price / 100).toFixed(2)}</s>
									<span class="product-sale-label">
										<span class="sale-total">-${discount}%</span>
									</span>
								</div>
							</div>
						`;
					} else {
						priceHTML = `
							<span> - </span>
							<div class="product-price">
								<span class="price">$${(selected.price / 100).toFixed(2)}</span>
							</div>
						`;
					}
					button.innerHTML = `${btyStrings.product.add_to_cart}${priceHTML}`;
					button.classList.remove('disabled');
				} else {
					button.innerHTML = btyStrings.product.out_of_stock;
					button.classList.add('disabled');
				}
			}

			if (pickup) {
				if (selected.available) btyPickupAvailability(doc, selected.id, pickup);
				else pickup.innerHTML = '';
			}

			let selectedOption = el.closest('.variant-field')?.querySelector('.field-title .selected-value');
			if (selectedOption) selectedOption.innerText = el.value.trim();

			document.dispatchEvent(new CustomEvent('product-variant-updated', { detail: { selected } }));
		};
	});

	let firstSelected = btySelectedVariant(variant_pick, variants, slider);
	if (!firstSelected && variants.length) {
		let cheapest = variants.reduce((prev, curr) => (curr.price < prev.price ? curr : prev));
		firstSelected = cheapest;
		variant_pick = cheapest.options.reduce((obj, val, index) => {
			obj['option' + (index + 1)] = val;
			return obj;
		}, {});

		if (productId) productId.value = cheapest.id;
		if (price) price.innerHTML = btyPriceHtml(cheapest.price, cheapest.compare_at_price, cheapest.unit_price, cheapest.unit_price_measurement);

		if (button) {
			if (cheapest.available) {
				button.classList.remove('disabled');
				button.innerHTML = btyStrings.product.add_to_cart;
			} else {
				button.classList.add('disabled');
				button.innerHTML = btyStrings.product.out_of_stock;
			}
		}

		field.forEach(el => {
			let value = cheapest.options.find(v => v === el.value);
			if (value) {
				el.checked = true;
				el.dispatchEvent(new Event('change'));
			}
		});
	} else if (firstSelected) {
		let checkedField = selector.querySelector('.field-value:checked');
		if (checkedField) checkedField.dispatchEvent(new Event('change'));
	}

	if (pickup && firstSelected && firstSelected.available) {
		btyPickupAvailability(doc, firstSelected.id, pickup);
	}

	if (input && firstSelected) {
		let max = quantity.find(e => e.id === firstSelected.id);
		if (max) {
			let qty = max.qty;
			if (qty > 0) {
				if (Number(input.value) > qty) input.value = qty;
				input.setAttribute('max', qty);
			} else input.removeAttribute('max');
		} else input.removeAttribute('max');
	}
}

function btyQuickView( doc = document ) {
	let box      = document.querySelector( '.quick-view' ),
		content  = box ? box.querySelector( '.quick-view-content' ) : false,
		selector = doc.querySelectorAll( '.product-quick-view' );

	if ( ! content || ! selector.length ) {
		return;
	}

	selector.forEach(
		function( el ) {
			el.onclick = function( e ) {
				e.preventDefault();
				let product_id = el.parentNode.getAttribute( 'data-id' );
				if ( product_id == box.getAttribute( 'data-id' ) ) {
					document.documentElement.classList.add( 'quick-view-open' );
					return;
				}

				document.documentElement.classList.add( 'quick-view-open' );
				box.classList.add( 'loading' );
				box.setAttribute( 'data-id', product_id );

				fetch( el.href + '?sections=quickview' )
					.then(
						function( r ) {
							if ( 200 !== r.status ) {
								console.log( 'Status Code: ' + r.status );
								throw r;
							}

							return r.json();
						}
					).then(
						function( res ) {
							content.innerHTML = btyGetSectionHtml( res.quickview );

							let options,
								gallery = document.querySelector( '.quick-view .product-gallery .swiper' );

							if ( gallery ) {
								options = {
									slidesPerView: 1,
									spaceBetween: 10,
									navigation: {
										nextEl: '.quick-view .swiper-button-next',
										prevEl: '.quick-view .swiper-button-prev'
									},
									pagination: {
										el: '.quick-view .swiper-pagination',
										type: 'bullets',
										clickable: true
									}
								}

								let quickViewSlide = new Swiper( gallery, options );

								btyQuickViewVariants( box, quickViewSlide );
							} else {
								btyQuickViewVariants( box, {} );
							}
						}
					).catch(
						function( e ) {
							console.error( e );
						}
					).finally(
						function() {
							// Re-init share.
							btyProductShare();

							// Re-init quantity.
							btyQuantityButton();

							// Update lazy load image.
							btyAnimationImageLoad( box, 0 );

							// Re-init add to cart.
							btyAddToCart();

							// Remove loading.
							box.classList.remove( 'loading' );

							// Close popup.
							btyClosePopup( 'quick-view-open', box );
						}
					);
			}
		}
	);
}

function btyUpdateStorage( key, array, id, type = 'local' ) {
	let storage = 'local' === type ? localStorage : sessionStorage;

	if ( ! storage.getItem( key ) ) {
		// Set key.
		storage.setItem( key, JSON.stringify( array ) );
	} else if ( ! storage.getItem( key ).includes( id ) ) {
		// Add new id.
		let parseStorage = btyJsonParse( storage.getItem( key ) );
		if ( ! parseStorage ) {
			return;
		}

		parseStorage.push( id );

		storage.setItem( key, JSON.stringify( parseStorage ) );
	}
}

function btyVariantsPopup( doc = document, popup ) {
	let variants = doc.querySelectorAll( '.product-variants' );
	if ( ! popup || ! variants.length ) {
		return;
	}

	variants.forEach(
		function( el ) {
			let variantData = el.querySelector( '[data-product-variants]' ),
				productId   = el.getAttribute( 'data-id' ),
				select      = el.querySelectorAll( '.field-value' ),
				imageLink   = popup.querySelector( '.preview-image [data-id="' + productId + '"]' ),
				image       = imageLink ? imageLink.querySelector( 'img' ) : false,
				price       = popup.querySelector( '[data-id="' + productId + '"] .product-price' ),
				stock       = popup.querySelector( '[data-id="' + productId + '"] .product-stock-status' ),
				form        = popup.querySelector( '.form-add-to-cart[data-id="' + productId + '"]' ),
				inputId     = form ? form.querySelector( '[name="id"]' ) : false,
				variantPick = {};

			if ( ! select.length ) {
				return;
			}

			variantData = variantData ? btyJsonParse( variantData.textContent ) : false;
			if ( ! variantData ) {
				return;
			}

			// Foreach.
			select.forEach(
				function( sel ) {
					variantPick[ sel.name ] = sel.value;

					// Change event.
					sel.onchange = function() {
						variantPick[ sel.name ] = sel.value;

						let selected = btySelectedVariant( variantPick, variantData );

						// Update image.
						if ( image ) {
							image.removeAttribute( 'srcset' );
							btyImageLoad( image, selected.featured_media.preview_image.src, selected.featured_media.id, image.parentNode );
						}

						// Update current variant id.
						if ( inputId ) {
							inputId.value = selected.id;
						}

						// Update stock status, add to cart button text.
						if ( selected.available ) {
							if ( form ) {
								form.classList.remove( 'disabled' );
							}

							if ( stock ) {
								stock.innerHTML = btyStrings.product.in_stock;
								stock.classList.remove( 'inventory--low' );
								stock.classList.add( 'inventory--high' );
							}
						} else {
							if ( form ) {
								form.classList.add( 'disabled' );
							}

							if ( stock ) {
								stock.innerHTML = btyStrings.product.out_of_stock;
								stock.classList.remove( 'inventory--high' );
								stock.classList.add( 'inventory--low' );
							}
						}

						// Update price.
						if ( price ) {
							price.innerHTML = btyPriceHtml( selected.price, selected.compare_at_price );
						}
					}
				}
			);

			// First matching variants.
			let firstSelected = btySelectedVariant( variantPick, variantData );
			if ( firstSelected.available ) {
				if ( form ) {
					form.classList.remove( 'disabled' );
				}

				if ( stock ) {
					stock.innerHTML = btyStrings.product.in_stock;
					stock.classList.remove( 'inventory--low' );
					stock.classList.add( 'inventory--high' );
				}
			} else {
				if ( form ) {
					form.classList.add( 'disabled' );
				}

				if ( stock ) {
					stock.innerHTML = btyStrings.product.out_of_stock;
					stock.classList.remove( 'inventory--high' );
					stock.classList.add( 'inventory--low' );
				}
			}

			if ( price ) {
				price.innerHTML = btyPriceHtml( firstSelected.price, firstSelected.compare_at_price );
			}
		}
	);
}

function btyValidateEmail( selector ) {
	let mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

	selector.focus();

	if ( selector.value.match( mailformat ) ) {
		selector.classList.remove( 'email-invalid' );

		return true;
	} else {
		selector.classList.add( 'email-invalid' );

		return false;
	}
}

function btyCheckInventoryOnLoad(doc = document) {
	let qtyInputs = doc.querySelectorAll('input[name="quantity"][max]');
	qtyInputs.forEach((qtyInput) => {
		let max = parseInt(qtyInput.getAttribute('max') || 0);
		let val = parseInt(qtyInput.value || 1);
		let warning = qtyInput.closest('form')?.querySelector('.product-warning');

		if (max && val > max) {
			qtyInput.value = max;
			if (warning) {
				warning.innerHTML = btyGlobals.svg_warning + `Chỉ còn ${max} sản phẩm trong kho.`;
			}
		}
	});
}

function btyProductInventory( doc = document, variants = {} ) {
	let variant   = {},
		quickAdds = doc.querySelectorAll( '.quick-add-box .field-swatch .selected' ),
		swatches  = doc.querySelector( '.product-swatches .selected' );
	if ( ! quickAdds.length && ! swatches ) {
		return;
	}

	let selected = btySelectedVariant( variant, variants );
}

function btyUpdateStockStatus( variants, card ) {
	let getSelected = card.querySelectorAll( '.field-swatch .selected' ),
		swatch      = card.querySelector( '.product-swatches .swatch.selected' );
	if ( getSelected.length ) {
		getSelected.forEach(
			function( el ) {
				let current = {};

				// Check color variant.
				if ( swatch ) {
					current[ swatch.getAttribute( 'data-name' ) ] = swatch.getAttribute( 'data-value' );
				}

				// Get siblings to save 2 fix variant, ex: ABC ABD ABX ABY.
				let siblings = btySiblings(
					el.parentNode,
					function( e ) {
						return e.classList.contains( 'field-swatch' );
					}
				);

				if ( siblings.length ) {
					siblings.forEach(
						function( si ) {
							let siSelected = si.querySelector( '.selected' );
							if ( ! siSelected ) {
								return;
							}

							current[ siSelected.getAttribute( 'data-name' ) ] = siSelected.getAttribute( 'data-value' );
						}
					);
				}

				// Update stock status on quick add.
				let indexSelected = el.parentNode.querySelectorAll( '.field-item' );
				if ( indexSelected.length ) {
					indexSelected.forEach(
						function( is ) {
							current[ is.getAttribute( 'data-name' ) ] = is.getAttribute( 'data-value' );

							let selected = btySelectedVariant( current, variants );
							if ( selected ) {
								if ( selected.available ) {
									is.classList.remove( 'soldout' );
								} else {
									is.classList.add( 'soldout' );
								}
							} else {
								is.classList.add( 'soldout' );
							}
						}
					);
				}
			}
		);
	}

	if ( swatch ) {
		swatch.parentNode.querySelectorAll( '.swatch' ).forEach(
			function( el ) {
				let current = {};

				if ( getSelected.length ) {
					getSelected.forEach(
						function( si ) {
							current[ si.getAttribute( 'data-name' ) ] = si.getAttribute( 'data-value' );
						}
					);
				}

				current[ el.getAttribute( 'data-name' ) ] = el.getAttribute( 'data-value' );

				let selected = btySelectedVariant( current, variants );
				if ( selected ) {
					if ( selected.available ) {
						el.classList.remove( 'soldout' );
					} else {
						el.classList.add( 'soldout' );
					}
				} else {
					el.classList.add( 'soldout' );
				}
			}
		);
	}
}

function btyUpdateStockStatusProduct( variants, element ) {
	let getSelected = element.querySelectorAll( '.variant-field .field-value:checked' );
	if ( ! getSelected.length ) {
		return;
	}

	getSelected.forEach(
		function( el ) {
			let current = {};

			// Get siblings to save 2 fix variant, ex: ABC ABD ABX ABY.
			let siblings = btySiblings(
				el.closest( '.variant-field' ),
				function( e ) {
					return e.classList.contains( 'variant-field' );
				}
			);

			if ( siblings.length ) {
				siblings.forEach(
					function( si ) {
						let siSelected = si.querySelector( '.field-value:checked' );
						if ( ! siSelected ) {
							return;
						}

						current[ siSelected.getAttribute( 'name' ) ] = siSelected.getAttribute( 'value' );
					}
				);
			}

			// Update stock status on quick add.
			let indexSelected = el.closest( '.variant-field' ).querySelectorAll( '.field-value' );
			if ( indexSelected.length ) {
				indexSelected.forEach(
					function( is ) {
						let inputId = is.getAttribute( 'id' ),
							label   = inputId ? is.parentNode.querySelector( 'label[for="' + inputId + '"]' ) : false;

						if ( ! label ) {
							return;
						}

						current[ is.getAttribute( 'name' ) ] = is.getAttribute( 'value' );

						let selected = btySelectedVariant( current, variants );
						if ( selected ) {
							if ( selected.available ) {
								label.classList.remove( 'soldout' );
							} else {
								label.classList.add( 'soldout' );
							}
						} else {
							label.classList.add( 'soldout' );
						}
					}
				);
			}
		}
	);
}

function btyQuickAdd( doc = document ) {
	let selectors = doc.querySelectorAll( '.quick-add .field-item' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			el.onclick = function() {
				let form   = el.closest( '[data-type="add-to-cart-form"]' ),
					submit = form ? form.querySelector( '[type="submit"]' ) : false,
					card   = form.closest( '.product-card' );
				if ( ! card || ! submit ) {
					return;
				}

				// Highlight selected.
				if ( ! el.classList.contains( 'selected' ) ) {
					let oldActive = el.parentNode.querySelector( '.field-item.selected' );
					if ( oldActive ) {
						oldActive.classList.remove( 'selected' );
					}

					el.classList.add( 'selected' );
				}

				// Update swatch.
				let variants  = form.querySelector( '[data-product-variants]' ),
					productId = form.querySelector( '[name="id"]' );

				if ( productId && variants ) {
					// Json parse.
					variants = btyJsonParse( variants.textContent );

					let variant_pick     = {},
						quickAddSelected = card.querySelectorAll( '.quick-add-box .selected' );

					if ( quickAddSelected.length ) {
						quickAddSelected.forEach(
							function( qas ) {
								variant_pick[ qas.getAttribute( 'data-name' ) ] = qas.getAttribute( 'data-value' );
							}
						);
					}

					// Get option from Swatch.
					let selectedSwatch = card.querySelector( '.product-swatches .swatch.selected' );
					if ( selectedSwatch ) {
						variant_pick[ selectedSwatch.getAttribute( 'data-name' ) ] = selectedSwatch.getAttribute( 'data-value' );
					}

					// Found selected variant.
					let selected = btySelectedVariant( variant_pick, variants );
					if ( selected ) {
						productId.value = selected.id;

						// Update stock status.
						btyUpdateStockStatus( variants, card );

						// Update product price.
						let price = card.querySelector( '.product-price' );
						if ( price ) {
							price.innerHTML = btyPriceHtml( selected.price, selected.compare_at_price, selected.unit_price, selected.unit_price_measurement );
						}

						if ( selected.available ) {
							el.classList.add( 'loading' );

							submit.click();
						} else {
							alert( 'This item is currently out of stock.' );

							return;
						}
					}
				}
			}

			el.addEventListener('keydown', function(e) {
			// Trigger on Enter or Space
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					el.click();
				}
			});
		}
	);
}

function btySwatch( doc = document ) {
	let swatch = doc.querySelectorAll( '.product-card .swatch' );
	if ( ! swatch.length ) {
		return;
	}

	swatch.forEach(
		function( el ) {
			el.onclick = function( e ) {
				e.preventDefault();

				if ( el.classList.contains( 'selected' ) ) {
					return;
				}

				let swatchValue = el.parentNode.querySelector( '.swatch-selected' );
				if ( swatchValue ) {
					swatchValue.innerText = el.innerText.trim();
				}

				// Get wrapper.
				let card    = el.closest( '.product-card' ),
					wrapper = card.querySelector( '.product-media-wrap' );
				if ( ! wrapper ) {
					return;
				}

				// Get product image.
				let image = wrapper.querySelector( '.product-image img' );

				// Handle loading image.
				const imageLoadHandle = function( dataSrc, main ) {
					if ( ! image ) {
						return;
					}

					let newImage     = new Image(),
						variationImg = el.getAttribute( 'data-key' ) || false,
						mainImg      = image.getAttribute( 'data-key' ) || false;

					newImage.crossOrigin = 'anonymous';

					// Main image.
					if ( main ) {
						variationImg = mainImg;
					}

					// Check local storage first.
					if ( sessionStorage.getItem( variationImg ) ) {
						image.src = sessionStorage.getItem( variationImg );
						image.removeAttribute( 'srcset' );
						return;
					}

					// Save main product image first.
					if ( 'string' !== typeof( image.getAttribute( 'data-loaded' ) ) && mainImg ) {
						let mainImage = new Image();

						mainImage.crossOrigin = 'anonymous';

						mainImage.onload = function() {
							let renderMainImage = btyGetImageSrc( mainImage );

							if ( mainImg ) {
								sessionStorage.setItem( mainImg, renderMainImage );
							}

							image.setAttribute( 'data-loaded', '' );
						}

						mainImage.src = image.src;
					}

					// Add loading animation.
					wrapper.classList.add( 'loading' );

					// Handle.
					newImage.onload = function() {
						wrapper.classList.remove( 'loading' );
						let renderImage = btyGetImageSrc( newImage );

						// Set final image src.
						image.src = renderImage;
						image.removeAttribute( 'srcset' );

						// Save image to local storage.
						if ( variationImg ) {
							sessionStorage.setItem( variationImg, renderImage );
						}
					}

					newImage.onerror = function() {
						wrapper.classList.remove( 'loading' );
					}

					// Set image src for 'newImage.onload' function handle.
					newImage.src = dataSrc;
				}

				// Get old selected.
				let oldActive = card.querySelector( '.swatch.selected' );
				if ( oldActive ) {
					oldActive.classList.remove( 'selected' );
				}

				// Set swatch selected.
				el.classList.add( 'selected' );

				// Update product image src.
				if ( image ) {
					let src = el.getAttribute( 'data-src' ) || '';
					if ( src && src != image.src ) {
						imageLoadHandle( src );
					}
				}

				// Update swatch.
				let form      = el.closest( '.product-card' ).querySelector( '[data-type="add-to-cart-form"]' ),
					addToCart = form ? form.querySelector( '.add-to-cart-button' ) : false,
					variants  = form ? form.querySelector( '[data-product-variants]' ) : false,
					productId = form ? form.querySelector( '[name="id"]' ) : false;

				if ( productId && variants ) {
					let variant_pick = {},
						dataName     = el.getAttribute( 'data-name' ),
						dataValue    = el.getAttribute( 'data-value' );

					variants = btyJsonParse( variants.textContent );

					variant_pick[ dataName ] = dataValue;

					// Update stock status.
					btyUpdateStockStatus( variants, card );

					// Get quick add value.
					let quickAdd = card.querySelectorAll( '.quick-add .field-item.selected' );
					if ( quickAdd.length ) {
						quickAdd.forEach(
							function( qa ) {
								variant_pick[ qa.getAttribute( 'data-name' ) ] = qa.getAttribute( 'data-value' );
							}
						);
					}

					let selected = btySelectedVariant( variant_pick, variants );
					if ( selected ) {
						productId.value = selected.id;

						// Dispatch 'change' event.
						productId.dispatchEvent( new Event( 'change' ) );

						// Update add to cart button status.
						if ( addToCart ) {
							if ( selected.available ) {
								addToCart.classList.remove( 'disabled' );
							} else {
								addToCart.classList.add( 'disabled' );
							}
						}

						// Update product url.
						let ahref = el.closest( '.product-card' ).querySelectorAll( 'a[href]:not(.swatch)' );
						if ( ahref.length ) {
							ahref.forEach(
								function( link ) {
									link.setAttribute( 'href', link.href.split( '?' )[1] ? link.href.split( '?' )[0] + '?variant=' + selected.id : link.href + '?variant=' + selected.id );
								}
							);
						}
					}
				}
			}
		}
	);
}

function btyProductTabs(doc = document, event = {}) {
	let selectors = doc.querySelectorAll('.tabs .tab-head');
	if (!selectors.length) return;

	selectors.forEach(function (el) {
		let wrap   = el.closest('.tabs'),
			index  = el.getAttribute('data-index'),
			tab    = wrap.querySelector('.tab-content[data-index="' + index + '"]'),
			slide  = wrap.querySelector('.product-main-slide:nth-child(' + index + ')'), // slide tương ứng
			arrows = wrap.querySelector('.unity-arrows[data-index="' + index + '"]');

		if (!tab) return;

		// Design mode.
		if (Shopify.designMode && Object.keys(event).length) {
			let currentTab = doc.querySelector('.tab-head[data-id="' + event.detail.blockId + '"]');
			if (currentTab) currentTab.click();
		}

		el.addEventListener('click', function () {

			if (el.classList.contains('active')) return;

			let navActived    = wrap.querySelector('.tab-head.active'),
				tabActived    = wrap.querySelector('.tab-content.active'),
				slideActived  = wrap.querySelector('.product-main-slide.active'),
				arrowsActived = wrap.querySelector('.unity-arrows.active');

			// Remove active
			if (navActived) {
				navActived.classList.remove('active');
				navActived.setAttribute('aria-selected', 'false');
				navActived.setAttribute('tabindex', '-1');
			}
			if (tabActived) tabActived.classList.remove('active');
			if (slideActived) {
				slideActived.classList.remove('active');
				slideActived.hidden = true;
			}
			if (arrowsActived) arrowsActived.classList.remove('active');

			// Add active
			el.classList.add('active');
			el.setAttribute('aria-selected', 'true');
			el.setAttribute('tabindex', '0');
			tab.classList.add('active');
			if (slide) {
				slide.hidden = false;
				slide.classList.add('active');
			}
			if (arrows) arrows.classList.add('active');

			wrap.querySelectorAll('.dropdown-item[data-index]').forEach(function (item) {
				item.setAttribute('aria-pressed', item.getAttribute('data-index') === index ? 'true' : 'false');
			});
		});

		el.addEventListener('keydown', function (event) {
			let keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
			if (!keys.includes(event.key)) return;

			let tabs = Array.from(wrap.querySelectorAll('.tab-head[role="tab"]')),
				currentIndex = tabs.indexOf(el),
				nextIndex = currentIndex;

			if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
			if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
			if (event.key === 'Home') nextIndex = 0;
			if (event.key === 'End') nextIndex = tabs.length - 1;

			event.preventDefault();
			tabs[nextIndex].focus();
			tabs[nextIndex].click();
		});
	});

	// Dropdown
	let dropdown = doc.querySelectorAll('.dropdown-content .dropdown-item[data-index]');
	if (dropdown.length) {
		dropdown.forEach(function (el) {
			el.addEventListener('click', function () {
				let parent  = el.closest('.tabs'),
					current = parent.querySelector('.tab-head[data-index="' + el.getAttribute('data-index') + '"]');
				if (!current) return;

				current.click();

				let summary = parent.querySelector('.dropdown-summary');
				if (summary) summary.focus();
			});
		});
	}
}

function btyPickupAvailability( doc = document, variant_id = false, pickup = false ) {
	let panel = document.querySelector( '.pickup-availability-panel' );
	if ( ! pickup || ! panel ) {
		return;
	}

	fetch( '/variants/' + variant_id + '?section_id=pickup-availability' )
		.then(
			function( r ) {
				if ( 200 !== r.status ) {
					console.log( 'Status Code: ' + r.status );
					throw r;
				}

				return r.text();
			}
		).then(
			function( res ) {
				pickup.innerHTML = btyGetSectionHtml( res, '.pickup-availability-info', 'outer' );
				panel.innerHTML  = btyGetSectionHtml( res, '.pickup-availability-modal', 'outer' );

				let toggle = pickup.querySelector( '.toggle-modal' );
				if ( toggle ) {
					toggle.onclick = function() {
						document.documentElement.classList.add( 'pickup-availability-open' );

						btyClosePopup( 'pickup-availability-open', panel );
					}
				}
			}
		).catch(
			function( e ) {
				console.error( e );
			}
		);
}

function btyPickupAvailabilityInit( doc = document ) {
	let variants = doc.querySelectorAll( '.product-variants' );
	if ( variants.length ) {
		return;
	}

	let inner     = doc.querySelector( '.product-summary-inner[data-selected-id]' ),
		pickup    = doc.querySelector( '.pickup-availability' ),
		productId = inner ? inner.getAttribute( 'data-selected-id' ) : false;

	if ( ! pickup || ! productId ) {
		return;
	}

	btyPickupAvailability( doc, productId, pickup );
}

function btyProductPopup( doc = document ) {
	let selectors = doc.querySelectorAll( '.product-popup' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			let summary = el.closest( '.product-summary' ),
				button  = el.querySelector( '.popup-toggle' ),
				view    = el.querySelector( '.popup-view' ),
				close   = el.querySelector( '.popup-close' );

			if ( ! summary || ! button || ! view || ! close ) {
				return;
			}

			button.onclick = function() {
				summary.classList.add( 'open' );

				// Target.
				view.onclick = function( e ) {
					if ( view !== e.target ) {
						return;
					}

					summary.classList.remove( 'open' );
				}

				// Use ESC key.
				document.addEventListener(
					'keyup',
					function( e ) {
						if ( 27 !== e.keyCode ) {
							return;
						}

						summary.classList.remove( 'open' );
					}
				);

				// Use close button.
				close.onclick = function() {
					summary.classList.remove( 'open' );
				}
			}
		}
	);
}

function btyProductShare( doc = document ) {
	let selector = doc.querySelector( '.product-share[data-os]' );
	if ( ! selector ) {
		return;
	}

	let button  = selector.querySelector( '.share-button' ),
		summary = selector.querySelector( 'summary' ),
		input   = selector.querySelector( '.field-input' ),
		message = selector.querySelector( '.share-message' ),
		copy    = selector.querySelector( '.share-button-copy' ),
		close   = selector.querySelector( '.share-button-close' );

	if ( ! button || ! summary || ! copy || ! close ) {
		return;
	}

	let closeAction = function() {
		summary.parentNode.removeAttribute( 'open' );
		close.classList.add( 'hidden' );
		message.classList.add( 'hidden' );
		message.textContent = '';
	}

	if ( navigator.share ) {
		button.classList.remove( 'hidden' );
		button.onclick = function() {
			navigator.share(
				{
					url: document.location.href,
					title: document.title
				}
			);
		}
	} else {
		summary.classList.remove( 'hidden' );

		copy.onclick = function() {
			navigator.clipboard.writeText( input.value ).then(
				function() {
					message.classList.remove( 'hidden' );
					close.classList.remove( 'hidden' );

					message.textContent = btyStrings.general.share_success;
				}
			);
		}

		// Click any to close.
		document.addEventListener(
			'click',
			function( e ) {
				if ( e.target.closest( '.product-share' ) ) {
					return;
				}

				closeAction();
			}
		);

		// Use ESC key.
		document.addEventListener(
			'keyup',
			function( e ) {
				if ( 27 !== e.keyCode ) {
					return;
				}

				closeAction();
			}
		);

		// Close button.
		close.onclick = closeAction;
	}
}

function btyRecipientForm( doc = document ) {
	let input  = doc.querySelector( '.recipient-checkbox-label input[type="checkbox"]' ),
		fields = doc.querySelector( '.recipient-fields' );

	if ( ! input || ! fields ) {
		return;
	}

	input.onchange = function() {
		if ( input.checked ) {
			fields.classList.add( 'open' );
		} else {
			fields.classList.remove( 'open' );
		}
	}
}

window.btyInitCommerce = function btyInitCommerce(doc = document) {
  btyRecipientForm(doc);
  btyQuickAdd(doc);
  btyQuantityButton(doc);
  btyProductPurchaseControls(doc);
  btyBackInStockButtons(doc);
  btySideCart();
  btyCheckInventoryOnLoad(doc);
  btyAddToCart(doc);
  btyAddMultiProductToCart(doc);
  btyUpdateProductQuantity(doc);
  btyQuickView(doc);
  btyQuickViewVariants(doc);
  btySwatch(doc);
  btyProductTabs(doc);
  btyPickupAvailabilityInit(doc);
  btyProductVariants(doc);
  btyProductPopup(doc);
  btyProductShare(doc);
  btyMinicartRecommendations(doc);
  btySideCartPopupOuter(doc);
  btyShortDescription(doc);
  btyAgreeToTerms(doc);
  btyUpdateProgressBarCart();
};
